<stay-list *ngIf="view.search && view.trip" [options]="view.search" [trip]="view.trip"></stay-list>